export default "__VITE_ASSET__B638zsQj__"